import React, { useEffect, useMemo, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pics = [
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzSdsbQZKxdT80fgUWVlcai-QqTNCzy2hA4MWvfzHy87BAV0vPgOOsRKk&s=10",
  "https://5.imimg.com/data5/IOS/Default/2024/9/452070597/JP/ZY/ZC/217158607/product-jpeg-500x500.png",
  "https://content.jdmagicbox.com/v2/comp/bangalore/v7/080pxx80.xx80.160606154530.m8v7/catalogue/raghavendra-traders-kumaraswamy-layout-1st-stage-bangalore-steel-dealers-y7aXMf2yI5.jpg",
  "https://content.jdmagicbox.com/comp/bhopal/g2/0755px755.x755.130103105757.q6g2/catalogue/hakeem-steel-corporation-lalghati-bhopal-tmt-steel-bar-dealers-jj96yfrbuo.jpg",
  "https://images.jdmagicbox.com/quickquotes/images_main/tmt-iron-bar-2013189868-ikzfmsrr.jpg",
  "https://content.jdmagicbox.com/comp/vijayawada/i4/0866px866.x866.220906152929.t3i4/catalogue/aanvi-steels-currency-nagar-vijayawada-iron-merchants-sfad3f51ew.jpg",
];

const dealers = [
  { id:1,name:"Sharma Auto Agency",code:"KMD-1001",state:"Uttar Pradesh",dist:"Agra Main Distributor",lat:27.1767,lng:78.0081,status:"red",jobs:4,location:"Agra, Uttar Pradesh",image:pics[0] },
  { id:2,name:"Jai Ambey Traders",code:"KMD-1044",state:"Rajasthan",dist:"Jaipur Main Distributor",lat:26.9124,lng:75.7873,status:"blue",jobs:2,location:"Jaipur, Rajasthan",image:pics[1] },
  { id:3,name:"Balaji Motors",code:"KMD-1119",state:"Maharashtra",dist:"Nagpur Main Distributor",lat:21.1458,lng:79.0882,status:"yellow",jobs:3,location:"Nagpur, Maharashtra",image:pics[2] },
  { id:4,name:"Shiv Shakti Dealer",code:"KMD-1190",state:"Gujarat",dist:"Ahmedabad Main Distributor",lat:23.0225,lng:72.5714,status:"green",jobs:1,location:"Ahmedabad, Gujarat",image:pics[3] },
  { id:5,name:"Govt High School Jamdi Demo Site",code:"KMD-1255",state:"Chhattisgarh",dist:"Central Distributor",lat:21.763393,lng:82.852868,status:"blue",jobs:3,location:"Jamdi, Chhattisgarh",image:"https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=900&q=80" },
  { id:6,name:"Krishna Dealer Point",code:"KMD-1288",state:"Odisha",dist:"Bhubaneswar Main Distributor",lat:20.2961,lng:85.8245,status:"yellow",jobs:5,location:"Bhubaneswar, Odisha",image:pics[4] },
  { id:7,name:"Maa Durga Agencies",code:"KMD-1307",state:"Madhya Pradesh",dist:"Bhopal Main Distributor",lat:23.2599,lng:77.4126,status:"red",jobs:2,location:"Bhopal, Madhya Pradesh",image:pics[5] },
  { id:8,name:"Shree Ganesh Traders",code:"KMD-1342",state:"Bihar",dist:"Patna Main Distributor",lat:25.5941,lng:85.1376,status:"green",jobs:1,location:"Patna, Bihar",image:pics[1] },
];

function markerIcon(status) {
  const color = { red:"#e1202a", blue:"#1f66db", yellow:"#f4c542", green:"#159a61" }[status];
  return L.divIcon({
    className: "custom-pin",
    html: `<div style="width:30px;height:30px;background:white;border-radius:50%;display:grid;place-items:center;box-shadow:0 2px 7px rgba(0,0,0,.35)"><div style="width:20px;height:20px;background:${color};border-radius:50%;border:3px solid white"></div></div>`,
    iconSize:[30,30],
    iconAnchor:[15,15],
  });
}

function KamdhenuDealerMap() {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markersRef = useRef([]);
  const [query, setQuery] = useState("");
  const [state, setState] = useState("");
  const [activeId, setActiveId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selected, setSelected] = useState(dealers[4]);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);
  const [mobileMenu, setMobileMenu] = useState(false);

  const states = useMemo(() => [...new Set(dealers.map(d => d.state))].sort(), []);

  const filtered = useMemo(() => {
    const q = query.toLowerCase().trim();
    return dealers.filter(d =>
      (!q || `${d.name} ${d.code} ${d.state}`.toLowerCase().includes(q)) &&
      (!state || d.state === state)
    );
  }, [query, state]);

  useEffect(() => {
    if (!mapRef.current || mapInstance.current) return;

    const map = L.map(mapRef.current, { zoomControl:true }).setView([22.8,79.2],5.3);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom:18,
      attribution:"© OpenStreetMap contributors",
    }).addTo(map);

    mapInstance.current = map;
    setTimeout(() => map.invalidateSize(), 0);

    return () => {
      map.remove();
      mapInstance.current = null;
    };
  }, []);

  const openDrawer = (dealer) => {
    setSelected(dealer);
    setActiveId(dealer.id);
    setDrawerOpen(true);
  };

  useEffect(() => {
    const map = mapInstance.current;
    if (!map) return;

    markersRef.current.forEach(m => m.remove());
    markersRef.current = [];

    filtered.forEach(dealer => {
      const marker = L.marker([dealer.lat, dealer.lng], { icon: markerIcon(dealer.status) }).addTo(map);
      marker.bindPopup(`
        <div class="popup">
          <img class="popup-img" src="${dealer.image}" alt="${dealer.name}">
          <div class="popup-body">
            <div class="popup-title">${dealer.name}</div>
            <div class="popup-sub">${dealer.code} • ${dealer.state}</div>
            <div class="popup-tags">
              <span class="tag">📌 ${dealer.location}</span>
              <span class="tag">📷 ${dealer.jobs + 5} Images</span>
              <span class="tag">🧾 ${dealer.jobs} Open Jobs</span>
            </div>
          </div>
        </div>
      `, { closeButton:true, maxWidth:280 });

      marker.on("click", () => openDrawer(dealer));
      markersRef.current.push(marker);
    });

    if (filtered.length && !activeId) {
      map.setView([filtered[0].lat, filtered[0].lng], 5.5);
    } else if (!filtered.length) {
      map.setView([22.8,79.2],5.3);
    }
  }, [filtered, activeId]);

  const focusDealer = (dealer) => {
    setActiveId(dealer.id);
    openDrawer(dealer);
    const map = mapInstance.current;
    if (map) {
      map.setView([dealer.lat, dealer.lng], 8, { animate:true });
      const marker = markersRef.current.find(m => {
        const ll = m.getLatLng();
        return Math.abs(ll.lat - dealer.lat) < 0.00001 && Math.abs(ll.lng - dealer.lng) < 0.00001;
      });
      if (marker) marker.openPopup();
    }
  };

  const clearFilters = () => {
    setQuery("");
    setState("");
    setActiveId(null);
    setDrawerOpen(false);
  };

  const openMaps = () => {
    window.open(`https://www.google.com/maps?q=${selected.lat},${selected.lng}`, "_blank", "noopener,noreferrer");
  };

    return (
    <>
      <style>{`

:root{--km-blue:#1758c7;--km-blue2:#2f6fed;--km-red:#e1202a;--km-yellow:#f4c542;--km-ink:#172132;--km-muted:#6d7787;--km-bg:#f3f6fb;--km-line:#e3e8f0;--km-green:#159a61}
*{box-sizing:border-box}html,body,#root{margin:0;min-height:100%;width:100%}button,input,select{font:inherit}body{background:#f5f7fb}img{max-width:100%}
.km-app{height:100vh;display:flex;flex-direction:column;font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:var(--km-ink);background:#fff;overflow:hidden}
.km-topbar{height:72px;flex:none;background:linear-gradient(90deg,#185acb,#12449c);color:#fff;display:flex;align-items:center;justify-content:space-between;padding:0 22px 0 18px;z-index:1000;box-shadow:0 2px 10px rgba(0,0,0,.15)}
.km-brand{display:flex;align-items:center;gap:12px}.km-brand img{width:146px;height:46px;border-radius:12px;object-fit:cover;box-shadow:0 2px 6px rgba(0,0,0,.2)}.km-brand h1{margin:0;font-size:20px;line-height:1.05}.km-brand small{color:#d9e6ff;font-size:11px}.km-company{height:44px;width:175px;object-fit:contain;background:#fff;border-radius:8px;padding:5px}.km-top-actions{display:flex;align-items:center;gap:9px}.km-live{font-size:11px;text-align:right;margin-right:4px}.km-live strong{display:block;color:#ffe162;font-size:18px}.km-live span{color:#d9e6ff}
.km-body{flex:1;display:flex;min-height:0}.km-left{width:315px;background:#fff;border-right:1px solid var(--km-line);display:flex;flex-direction:column;z-index:700}.filter-head{padding:17px 15px 12px;border-bottom:1px solid var(--km-line)}.section-title{font-size:14px;font-weight:900;text-transform:uppercase;letter-spacing:.05em;color:#64728a}.section-title span{color:var(--km-red)}.field{margin-top:12px}.field label{display:block;font-size:10px;text-transform:uppercase;color:#708098;font-weight:800;margin-bottom:6px}.field input,.field select{width:100%;border:1px solid #cfd7e2;border-radius:8px;padding:10px 11px;font-size:12px;background:#fff}.clear{width:100%;margin-top:10px;border:0;border-radius:8px;padding:10px;background:#f04444;color:#fff;font-weight:800;cursor:pointer}.state-count{font-size:11px;color:var(--km-muted);margin-top:8px}.dealer-list{overflow:auto;flex:1}.dealer{padding:13px 14px;border-bottom:1px solid #eef1f5;cursor:pointer}.dealer:hover,.dealer.active{background:#eff5ff}.dealer.active{border-left:4px solid var(--km-blue);padding-left:10px}.dealer-top{display:flex;gap:9px}.dealer-icon{width:35px;height:35px;border-radius:50%;background:#eaf2ff;display:grid;place-items:center;font-size:16px;flex:none}.dealer-name{font-size:12px;font-weight:900;line-height:1.25}.meta{font-size:10px;color:#56637a;margin-top:4px;line-height:1.65}.meta b{color:var(--km-blue)}.openmap{display:inline-block;margin-top:8px;background:var(--km-blue2);color:#fff;padding:6px 9px;border-radius:7px;font-size:10px;font-weight:800}
.km-mapwrap{position:relative;flex:1;min-width:0}.km-map{position:absolute;inset:0}.map-help{position:absolute;top:12px;right:12px;width:285px;background:#fff;border-radius:12px;padding:14px 15px;box-shadow:0 9px 25px rgba(31,49,79,.15);z-index:500}.map-help h3{margin:0 0 6px;font-size:13px}.map-help p{margin:0;color:#56637a;font-size:11px;line-height:1.55}.map-legend{position:absolute;left:14px;bottom:15px;background:#fff;padding:11px 12px;border-radius:11px;box-shadow:0 8px 22px rgba(31,49,79,.14);z-index:500;font-size:10px}.lg{display:flex;gap:7px;align-items:center;margin-top:6px}.lg:first-child{margin-top:0}.dot{width:10px;height:10px;border-radius:50%}.blue{background:#1f66db}.red{background:#e1202a}.yellow{background:#f4c542}.green{background:#159a61}
.leaflet-control-zoom a{font-weight:900}.leaflet-popup-content{margin:0;width:270px!important}.popup{padding:0}.popup-img{width:100%;height:115px;object-fit:cover;border-radius:10px 10px 0 0}.popup-body{padding:11px 12px}.popup-title{font-weight:900;font-size:14px}.popup-sub{font-size:10px;color:var(--km-muted);margin-top:3px}.popup-tags{display:flex;gap:6px;flex-wrap:wrap;margin:8px 0}.tag{background:#eef3fb;color:#4e5c72;border-radius:99px;padding:4px 7px;font-size:9px;font-weight:700}
.km-right{position:absolute;right:0;top:0;bottom:0;width:440px;background:#fff;box-shadow:-8px 0 30px rgba(26,42,67,.18);z-index:800;transform:translateX(100%);transition:transform .28s ease;display:flex;flex-direction:column}.km-right.open{transform:translateX(0)}.drawer-head{padding:16px 16px 12px;border-bottom:1px solid var(--km-line);display:flex;justify-content:space-between}.drawer-title{font-size:18px;font-weight:900}.drawer-sub{font-size:11px;color:var(--km-muted);margin-top:3px}.close{border:0;background:transparent;font-size:26px;cursor:pointer}.drawer-content{overflow:auto;padding:14px}.property-hero{height:170px;width:100%;object-fit:cover;border-radius:12px}.info{margin:12px 0;display:grid;grid-template-columns:1fr 1fr;gap:8px}.info-card{background:#f6f8fb;border-radius:9px;padding:9px}.info-card span{display:block;color:#7b8798;font-size:9px}.info-card strong{display:block;margin-top:4px;font-size:11px}.section-box{border-top:1px solid #edf0f4;padding-top:12px;margin-top:12px}.section-box h4{margin:0 0 9px;font-size:12px}.note{background:#f1f5fb;color:#56637a;border-radius:9px;padding:10px;font-size:10px;line-height:1.5}.actions2{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:10px}.bigbtn{border:0;border-radius:9px;padding:10px;font-size:11px;font-weight:900;cursor:pointer;background:var(--km-blue2);color:#fff}.bigbtn.secondary{background:#eff2f6;color:#3d4c62}.gallery-grid{display:grid;grid-template-columns:1fr 1fr;gap:9px}.thumb{height:100px;border-radius:9px;object-fit:cover;width:100%;cursor:pointer;border:1px solid #dde4ed}.thumb:hover{transform:translateY(-1px);box-shadow:0 6px 16px rgba(24,51,87,.14)}.approved-text{color:#159a61}
.overlay{position:fixed;inset:0;background:rgba(5,12,24,.82);z-index:1500;display:flex;align-items:center;justify-content:center;padding:20px}.gallery-modal{width:min(1150px,94vw);height:min(84vh,860px);background:#10151e;border-radius:14px;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.4)}.gallery-head{height:56px;color:#fff;display:flex;align-items:center;justify-content:space-between;padding:0 17px}.gallery-head strong{font-size:14px}.gallery-close{border:0;background:transparent;color:#fff;font-size:28px;cursor:pointer}.gallery-main{flex:1;display:flex;align-items:center;justify-content:center;position:relative;padding:10px}.gallery-main img{max-width:82%;max-height:100%;object-fit:contain}.navarr{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;border:0;background:rgba(255,255,255,.12);color:#fff;font-size:28px;cursor:pointer}.navarr.leftarr{left:15px}.navarr.rightarr{right:15px}.gallery-thumbs{display:flex;gap:8px;overflow:auto;padding:9px 13px 13px}.gallery-thumbs img{height:60px;width:90px;object-fit:cover;border-radius:6px;cursor:pointer;opacity:.7}.gallery-thumbs img.active{opacity:1;outline:2px solid var(--km-blue2)}
.km-hamb{display:none;border:0;background:rgba(255,255,255,.15);color:#fff;border-radius:8px;width:39px;height:39px}
@media(max-width:950px){.km-left{width:270px}.km-right{width:390px}.map-help{width:245px}.km-company{display:none}}
@media(max-width:700px){.km-left{width:100%;position:absolute;left:0;top:72px;bottom:0;transform:translateX(-100%);transition:.25s}.km-left.open{transform:translateX(0)}.km-right{width:92vw}.km-top-actions .km-live{display:none}.km-brand h1{font-size:17px}.km-topbar{padding-right:10px}.km-hamb{display:inline-block}.map-help{display:none}}

      `}
      </style>

    <div className="km-app">
      <header className="km-topbar">
        <div className="km-brand">
          <button className="km-hamb" onClick={() => setMobileMenu(v => !v)} type="button">☰</button>
          <img src="assets/img/logo.webp" alt="SNAP4ME" />
          <div><h1>SNAP4ME —  Dealer Marketing Activity Map</h1><small>Dealer Location &amp; Marketing Activity Viewer</small></div>
        </div>
        <div className="km-top-actions">
          <div className="km-live"><span>Map Dashboard Live</span><strong>12,486 Dealers</strong></div>
          <img className="km-company" src="https://www.snap4me.com/_next/static/media/logo.ca095751.svg" alt="Kamdhenu Group" />
        </div>
      </header>

      <div className="km-body">
        <aside className={`km-left ${mobileMenu ? "open" : ""}`}>
          <div className="filter-head">
            <div className="section-title"><span>📍</span> ALL DEALERS</div>
            <div className="field"><label>Search</label><input value={query} onChange={e => setQuery(e.target.value)} placeholder="Dealer Name / Code / Serial No." /></div>
            <div className="field">
              <label>State</label>
              <select value={state} onChange={e => setState(e.target.value)}>
                <option value="">All States (12,486)</option>
                {states.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <button className="clear" onClick={clearFilters} type="button">✕ Clear Filters</button>
            <div className="state-count">Showing {filtered.length.toLocaleString()} dealers</div>
          </div>

          <div className="dealer-list">
            {filtered.map(dealer => (
              <div key={dealer.id} className={`dealer ${activeId === dealer.id ? "active" : ""}`} onClick={() => focusDealer(dealer)}>
                <div className="dealer-top">
                  <div className="dealer-icon">🏪</div>
                  <div>
                    <div className="dealer-name">{dealer.name}</div>
                    <div className="meta">🆔 <b>{dealer.code}</b><br />📍 {dealer.location}<br />📊 <b>{dealer.jobs}</b> open marketing job(s)<br />🖼️ <b>{dealer.jobs + 5}</b> property images</div>
                    <span className="openmap">Open on Map</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </aside>

        <section className="km-mapwrap">
          <div ref={mapRef} className="km-map" />

          <div className="map-help"><h3>🔍 How to Use</h3><p>Click any dealer marker → review the dealer profile → open <b>View Property &amp; Images</b> to inspect uploaded photos and open any image in the gallery.</p></div>

          <div className="map-legend">
            <b>Dealer Status</b>
            <div className="lg"><span className="dot blue" />Approved / Active</div>
            <div className="lg"><span className="dot red" />Pending Activity</div>
            <div className="lg"><span className="dot yellow" />Design / Execution</div>
            <div className="lg"><span className="dot green" />Completed</div>
          </div>

          <aside className={`km-right ${drawerOpen ? "open" : ""}`}>
            <div className="drawer-head">
              <div><div className="drawer-title">{selected.name}</div><div className="drawer-sub">{selected.code} • {selected.state}</div></div>
              <button className="close" onClick={() => setDrawerOpen(false)} type="button">×</button>
            </div>

            <div className="drawer-content">
              <img className="property-hero" src={selected.image} alt="Dealer property" />
              <div className="info">
                <div className="info-card"><span>Dealer Code</span><strong>{selected.code}</strong></div>
                <div className="info-card"><span>State</span><strong>{selected.state}</strong></div>
                <div className="info-card"><span>Distributor</span><strong>{selected.dist}</strong></div>
                <div className="info-card"><span>Open Jobs</span><strong>{selected.jobs}</strong></div>
              </div>

              <div className="section-box">
                <h4>Location</h4>
                <div className="note">{selected.lat.toFixed(6)}, {selected.lng.toFixed(6)} • {selected.location}</div>
                <div className="actions2">
                  <button className="bigbtn" onClick={openMaps} type="button">🌐 Open in Google Maps</button>
                  <button className="bigbtn secondary" onClick={() => { setGalleryIndex(0); setGalleryOpen(true); }} type="button">🖼 View Property Images</button>
                </div>
              </div>

              <div className="section-box">
                <h4>Marketing Activity</h4>
                <div className="info">
                  <div className="info-card"><span>Current Type</span><strong>Hoarding</strong></div>
                  <div className="info-card"><span>Specification</span><strong>20 × 10 ft</strong></div>
                  <div className="info-card"><span>Status</span><strong className="approved-text">Approved</strong></div>
                  <div className="info-card"><span>Evidence</span><strong>{selected.jobs + 5} images</strong></div>
                </div>
              </div>

              <div className="section-box">
                <h4>Property Images</h4>
                <div className="gallery-grid">
                  {pics.map((p, i) => <img key={p} className="thumb" src={p} alt={`Property ${i + 1}`} onClick={() => { setGalleryIndex(i); setGalleryOpen(true); }} />)}
                </div>
              </div>
            </div>
          </aside>
        </section>
      </div>

      {galleryOpen && (
        <div className="overlay open" onClick={e => e.target === e.currentTarget && setGalleryOpen(false)}>
          <div className="gallery-modal">
            <div className="gallery-head"><strong>Property Image Gallery</strong><button className="gallery-close" onClick={() => setGalleryOpen(false)} type="button">×</button></div>
            <div className="gallery-main">
              <button className="navarr leftarr" onClick={() => setGalleryIndex(i => (i - 1 + pics.length) % pics.length)} type="button">‹</button>
              <img src={pics[galleryIndex]} alt={`Gallery ${galleryIndex + 1}`} />
              <button className="navarr rightarr" onClick={() => setGalleryIndex(i => (i + 1) % pics.length)} type="button">›</button>
            </div>
            <div className="gallery-thumbs">
              {pics.map((p, i) => <img key={p} src={p} className={i === galleryIndex ? "active" : ""} alt={`Thumbnail ${i + 1}`} onClick={() => setGalleryIndex(i)} />)}
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
}

export default KamdhenuDealerMap;
